// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LpRouteImport } from './routes/_lp'
import { Route as SiteRouteImport } from './routes/_site'
import { Route as StyleguideRouteImport } from './routes/styleguide'
import { Route as SiteIndexRouteImport } from './routes/_site.index'
import { Route as SiteAboutRouteImport } from './routes/_site.about'
import { Route as SiteBookRouteImport } from './routes/_site.book'
import { Route as SiteContactRouteImport } from './routes/_site.contact'
import { Route as SiteHowWeWorkRouteImport } from './routes/_site.how-we-work'
import { Route as SitePricingRouteImport } from './routes/_site.pricing'
import { Route as SiteThankYouRouteImport } from './routes/_site.thank-you'
import { Route as ScopeTokenRouteImport } from './routes/scope.$token'
import { Route as LpLpCampaignRouteImport } from './routes/_lp.lp.$campaign'
import { Route as LpLpBusinessPlanRouteImport } from './routes/_lp.lp.business-plan'
import { Route as LpLpSbaLoansRouteImport } from './routes/_lp.lp.sba-loans'
import { Route as SiteBlogIndexRouteImport } from './routes/_site.blog.index'
import { Route as SiteBlogSlugRouteImport } from './routes/_site.blog.$slug'
import { Route as SiteGuidesBusinessPlanChecklistRouteImport } from './routes/_site.guides.business-plan-checklist'
import { Route as SiteGuidesSbaLoanGuideRouteImport } from './routes/_site.guides.sba-loan-guide'
import { Route as SiteLegalAccessibilityRouteImport } from './routes/_site.legal.accessibility'
import { Route as SiteLegalDisclaimerRouteImport } from './routes/_site.legal.disclaimer'
import { Route as SiteLegalPrivacyRouteImport } from './routes/_site.legal.privacy'
import { Route as SiteLegalTermsRouteImport } from './routes/_site.legal.terms'
import { Route as SiteResultsIndexRouteImport } from './routes/_site.results.index'
import { Route as SiteResultsSlugRouteImport } from './routes/_site.results.$slug'
import { Route as SiteServicesIndexRouteImport } from './routes/_site.services.index'
import { Route as SiteServicesAiEnablementRouteImport } from './routes/_site.services.ai-enablement'
import { Route as SiteServicesAiImplementationRouteImport } from './routes/_site.services.ai-implementation'
import { Route as SiteServicesAiOpportunityAssessmentRouteImport } from './routes/_site.services.ai-opportunity-assessment'
import { Route as SiteServicesBusinessPlanWritingRouteImport } from './routes/_site.services.business-plan-writing'
import { Route as SiteServicesGrantsAndFundingRouteImport } from './routes/_site.services.grants-and-funding'
import { Route as SiteServicesSbaLoanConsultingRouteImport } from './routes/_site.services.sba-loan-consulting'
import { Route as SiteServicesWorkflowAutomationRouteImport } from './routes/_site.services.workflow-automation'
import { Route as SiteToolsIndexRouteImport } from './routes/_site.tools.index'
import { Route as SiteToolsAiOpportunityScorecardRouteImport } from './routes/_site.tools.ai-opportunity-scorecard'
import { Route as SiteBlogCategoryCategoryRouteImport } from './routes/_site.blog.category.$category'

const LpRoute = LpRouteImport.update({
            id: '/_lp',getParentRoute: () => rootRouteImport
          })
const SiteRoute = SiteRouteImport.update({
            id: '/_site',getParentRoute: () => rootRouteImport
          })
const StyleguideRoute = StyleguideRouteImport.update({
            id: '/styleguide',path: '/styleguide',getParentRoute: () => rootRouteImport
          })
const SiteIndexRoute = SiteIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SiteRoute
          })
const SiteAboutRoute = SiteAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => SiteRoute
          })
const SiteBookRoute = SiteBookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => SiteRoute
          })
const SiteContactRoute = SiteContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => SiteRoute
          })
const SiteHowWeWorkRoute = SiteHowWeWorkRouteImport.update({
            id: '/how-we-work',path: '/how-we-work',getParentRoute: () => SiteRoute
          })
const SitePricingRoute = SitePricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => SiteRoute
          })
const SiteThankYouRoute = SiteThankYouRouteImport.update({
            id: '/thank-you',path: '/thank-you',getParentRoute: () => SiteRoute
          })
const ScopeTokenRoute = ScopeTokenRouteImport.update({
            id: '/scope/$token',path: '/scope/$token',getParentRoute: () => rootRouteImport
          })
const LpLpCampaignRoute = LpLpCampaignRouteImport.update({
            id: '/lp/$campaign',path: '/lp/$campaign',getParentRoute: () => LpRoute
          })
const LpLpBusinessPlanRoute = LpLpBusinessPlanRouteImport.update({
            id: '/lp/business-plan',path: '/lp/business-plan',getParentRoute: () => LpRoute
          })
const LpLpSbaLoansRoute = LpLpSbaLoansRouteImport.update({
            id: '/lp/sba-loans',path: '/lp/sba-loans',getParentRoute: () => LpRoute
          })
const SiteBlogIndexRoute = SiteBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => SiteRoute
          })
const SiteBlogSlugRoute = SiteBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => SiteRoute
          })
const SiteGuidesBusinessPlanChecklistRoute = SiteGuidesBusinessPlanChecklistRouteImport.update({
            id: '/guides/business-plan-checklist',path: '/guides/business-plan-checklist',getParentRoute: () => SiteRoute
          })
const SiteGuidesSbaLoanGuideRoute = SiteGuidesSbaLoanGuideRouteImport.update({
            id: '/guides/sba-loan-guide',path: '/guides/sba-loan-guide',getParentRoute: () => SiteRoute
          })
const SiteLegalAccessibilityRoute = SiteLegalAccessibilityRouteImport.update({
            id: '/legal/accessibility',path: '/legal/accessibility',getParentRoute: () => SiteRoute
          })
const SiteLegalDisclaimerRoute = SiteLegalDisclaimerRouteImport.update({
            id: '/legal/disclaimer',path: '/legal/disclaimer',getParentRoute: () => SiteRoute
          })
const SiteLegalPrivacyRoute = SiteLegalPrivacyRouteImport.update({
            id: '/legal/privacy',path: '/legal/privacy',getParentRoute: () => SiteRoute
          })
const SiteLegalTermsRoute = SiteLegalTermsRouteImport.update({
            id: '/legal/terms',path: '/legal/terms',getParentRoute: () => SiteRoute
          })
const SiteResultsIndexRoute = SiteResultsIndexRouteImport.update({
            id: '/results/',path: '/results/',getParentRoute: () => SiteRoute
          })
const SiteResultsSlugRoute = SiteResultsSlugRouteImport.update({
            id: '/results/$slug',path: '/results/$slug',getParentRoute: () => SiteRoute
          })
const SiteServicesIndexRoute = SiteServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => SiteRoute
          })
const SiteServicesAiEnablementRoute = SiteServicesAiEnablementRouteImport.update({
            id: '/services/ai-enablement',path: '/services/ai-enablement',getParentRoute: () => SiteRoute
          })
const SiteServicesAiImplementationRoute = SiteServicesAiImplementationRouteImport.update({
            id: '/services/ai-implementation',path: '/services/ai-implementation',getParentRoute: () => SiteRoute
          })
const SiteServicesAiOpportunityAssessmentRoute = SiteServicesAiOpportunityAssessmentRouteImport.update({
            id: '/services/ai-opportunity-assessment',path: '/services/ai-opportunity-assessment',getParentRoute: () => SiteRoute
          })
const SiteServicesBusinessPlanWritingRoute = SiteServicesBusinessPlanWritingRouteImport.update({
            id: '/services/business-plan-writing',path: '/services/business-plan-writing',getParentRoute: () => SiteRoute
          })
const SiteServicesGrantsAndFundingRoute = SiteServicesGrantsAndFundingRouteImport.update({
            id: '/services/grants-and-funding',path: '/services/grants-and-funding',getParentRoute: () => SiteRoute
          })
const SiteServicesSbaLoanConsultingRoute = SiteServicesSbaLoanConsultingRouteImport.update({
            id: '/services/sba-loan-consulting',path: '/services/sba-loan-consulting',getParentRoute: () => SiteRoute
          })
const SiteServicesWorkflowAutomationRoute = SiteServicesWorkflowAutomationRouteImport.update({
            id: '/services/workflow-automation',path: '/services/workflow-automation',getParentRoute: () => SiteRoute
          })
const SiteToolsIndexRoute = SiteToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => SiteRoute
          })
const SiteToolsAiOpportunityScorecardRoute = SiteToolsAiOpportunityScorecardRouteImport.update({
            id: '/tools/ai-opportunity-scorecard',path: '/tools/ai-opportunity-scorecard',getParentRoute: () => SiteRoute
          })
const SiteBlogCategoryCategoryRoute = SiteBlogCategoryCategoryRouteImport.update({
            id: '/blog/category/$category',path: '/blog/category/$category',getParentRoute: () => SiteRoute
          })





const LpRouteChildren = {
  LpLpCampaignRoute: LpLpCampaignRoute,LpLpBusinessPlanRoute: LpLpBusinessPlanRoute,LpLpSbaLoansRoute: LpLpSbaLoansRoute
}

const LpRouteWithChildren = LpRoute._addFileChildren(LpRouteChildren)




const SiteRouteChildren = {
  SiteAboutRoute: SiteAboutRoute,SiteBookRoute: SiteBookRoute,SiteContactRoute: SiteContactRoute,SiteHowWeWorkRoute: SiteHowWeWorkRoute,SitePricingRoute: SitePricingRoute,SiteThankYouRoute: SiteThankYouRoute,SiteIndexRoute: SiteIndexRoute,SiteBlogSlugRoute: SiteBlogSlugRoute,SiteGuidesBusinessPlanChecklistRoute: SiteGuidesBusinessPlanChecklistRoute,SiteGuidesSbaLoanGuideRoute: SiteGuidesSbaLoanGuideRoute,SiteLegalAccessibilityRoute: SiteLegalAccessibilityRoute,SiteLegalDisclaimerRoute: SiteLegalDisclaimerRoute,SiteLegalPrivacyRoute: SiteLegalPrivacyRoute,SiteLegalTermsRoute: SiteLegalTermsRoute,SiteResultsSlugRoute: SiteResultsSlugRoute,SiteServicesAiEnablementRoute: SiteServicesAiEnablementRoute,SiteServicesAiImplementationRoute: SiteServicesAiImplementationRoute,SiteServicesAiOpportunityAssessmentRoute: SiteServicesAiOpportunityAssessmentRoute,SiteServicesBusinessPlanWritingRoute: SiteServicesBusinessPlanWritingRoute,SiteServicesGrantsAndFundingRoute: SiteServicesGrantsAndFundingRoute,SiteServicesSbaLoanConsultingRoute: SiteServicesSbaLoanConsultingRoute,SiteServicesWorkflowAutomationRoute: SiteServicesWorkflowAutomationRoute,SiteToolsAiOpportunityScorecardRoute: SiteToolsAiOpportunityScorecardRoute,SiteBlogIndexRoute: SiteBlogIndexRoute,SiteResultsIndexRoute: SiteResultsIndexRoute,SiteServicesIndexRoute: SiteServicesIndexRoute,SiteToolsIndexRoute: SiteToolsIndexRoute,SiteBlogCategoryCategoryRoute: SiteBlogCategoryCategoryRoute
}

const SiteRouteWithChildren = SiteRoute._addFileChildren(SiteRouteChildren)

const rootRouteChildren = {
  LpRoute: LpRouteWithChildren,SiteRoute: SiteRouteWithChildren,StyleguideRoute: StyleguideRoute,ScopeTokenRoute: ScopeTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)